import React from 'react';

import BaseDetailScreen from '../../BaseDetailScreen';
import getDisclaimer from './getDisclaimer';


const Component = ({ view, offerId }) => {
  const disclaimer = getDisclaimer(view);

  return (
    <BaseDetailScreen
      pageHeading={disclaimer.header}
      backTo={`/external-invest/${offerId}${disclaimer.backTo}`}
      backLabel={disclaimer.backLabel}
    >
      { disclaimer.text() }
    </BaseDetailScreen>
  );
};

Component.displayName = 'DisclaimerViews';

export default Component;



// WEBPACK FOOTER //
// ./src/components/ExternalInvest/DisclaimerViews/index.js